class IdentityTagify {
    constructor(inputElm, identities) {
        const onSelectSuggestion = (e) => {
            if( e.detail.event.target.matches('.remove-all-tags')) {
                tagify.removeAllTags()
            }
            // custom class from "dropdownHeaderTemplate"
            else if( e.detail.event.target.matches('.add-all-tags') ) {
                let selectedItems = tagify.dropdown.getAllSuggestionsRefs();
                let tagsToAdd = [];
                for (let i in selectedItems){
                    if(selectedItems[i].attributes.id){
                        let obj = identities.find(o => o.value === selectedItems[i].attributes.value.value);
                        tagsToAdd.push(obj);
                    }
                }
                tagify.addTags(tagsToAdd, true, true);
                tagify.dropdown.hide();
            }
        }

        const tagify = new Tagify(inputElm, {
            tagTextProp: 'name', // very important since a custom template is used with this property as text
            enforceWhitelist: true,
            skipInvalid: true, // do not remporarily add invalid tags
            edit: false,
            dropdown: {
                closeOnSelect: false,
                enabled: 0,
                maxItems: 500,
                searchKeys: ['name']  // very important to set by which keys to search for suggesttions when typing
            },
            templates: {
                tag: this.tagTemplate,
                dropdownItem: this.suggestionItemTemplate,
                dropdownHeader: this.dropdownHeaderTemplate,
                dropdownItemNoMatch: tagData =>
                    `<div class='${tagify.settings.classNames.dropdownItem} text-primary' value="noMatch" tabindex="0" role="option">
                        No Groups found for: <strong>${tagData.value}</strong>
                    </div>`
            },
            whitelist: identities,
            maxTags: 10,
            minTags: 1,
        }).on('dropdown:select', onSelectSuggestion);

        function updateRemoveButtons() {
            var tags = tagify.DOM.scope.querySelectorAll('.tagify__tag');
            tags.forEach(function(tag) {
                var removeBtn = tag.querySelector('.tagify__tag__removeBtn');
                if (tagify.value.length < 2) {
                    removeBtn.style.display = 'none';
                } else {
                    removeBtn.style.display = '';
                }
            });
        }

        tagify.on('add', updateRemoveButtons);
        tagify.on('remove', updateRemoveButtons);

        // Initial update after rendering tags
        updateRemoveButtons();

        return tagify;
    }


    tagTemplate(tagData){
        const getGroupTagHtml = (tagData) => {
            return '<div class="d-flex align-items-center p-0">' +
                '       <div class="symbol symbol-25px symbol-circle rounded-circle border ga-border-primary-300 me-2">' +
                '          <div class="symbol-label bg-light-primary border border-2 border-white">\n' +
                '               <img src="/vendor/production/avatars/svg/'+ tagData['icon'] +'.svg" style="width:25px;border-radius: 100%" alt="avatar">\n' +
                '           </div>\n' +
                '       </div>'+
                '       <div class="d-flex justify-content-start flex-column me-2 rounded-0">' +
                '           <div class="d-flex align-items-center"><span class="fw-bold text-nowrap text-primary fs-6">'+tagData['name']+'</span></div>' +
                '       </div>' +
                '   </div>';
        }

        return `<tag title="${tagData.username}"
                        contenteditable='false'
                        spellcheck='false'
                        tabIndex="-1"
                        class="tagify__tag p-1 ${tagData.class ? tagData.class : ""}"
                        ${this.getAttributes(tagData)}>
                    <x title='' class='tagify__tag__removeBtn' role='button' aria-label='remove tag'></x>
                    ${getGroupTagHtml(tagData)}
                </tag>`;
    }

    suggestionItemTemplate(tagData){
        const getGroupHtml = (tagData) => {
            return '<div class="d-flex align-items-center p-0">' +
                '       <div class="symbol symbol-35px symbol-circle rounded-circle border ga-border-primary-300 me-2">' +
                '          <div class="symbol-label bg-light-primary border border-2 border-white">\n' +
                '               <img src="/vendor/production/avatars/svg/'+ tagData['icon'] +'.svg" style="width:25px;border-radius: 100%" alt="avatar">\n' +
                '           </div>\n' +
                '       </div>'+
                '       <div class="d-flex justify-content-start flex-column">' +
                '           <div class="d-flex align-items-center"><span class="fw-bold text-nowrap text-primary fs-6">'+tagData['name']+'</span></div>' +
                '       </div>' +
                '   </div>';
        }

        return `<div ${this.getAttributes(tagData)}
                    class='tagify__dropdown__item ${tagData.class ? tagData.class : ""}'
                    tabindex="0"
                    role="option">
                    ${getGroupHtml(tagData)}
                </div>`;
    }

    dropdownHeaderTemplate(suggestions){
        return `<header data-selector='tagify-suggestions-header' class="${this.settings.classNames.dropdownItem}">
                    <div class="d-flex justify-content-between text-primary">
                        <strong class="text-decoration-underline-ga primary add-all-tags">Add All</strong>
                        ${this.value.length ? `<a class='remove-all-tags text-decoration-underline-ga danger text-danger'>Remove all</a>` : ''}
                    </div>
                    <span class="text-primary">${suggestions.length} Identities</span>
                </header>`;
    }
}
window.IdentityTagify = IdentityTagify;